import type { NextPage } from 'next'
import { PrintDataDelivery } from '@/client/modules/PrintDataDelivery'
import { PrintDataDeliveryProps } from '@/client/modules/PrintDataDelivery/types'
import { getCMSContent } from '@/client/utils'

const PrintDataDeliveryPage: NextPage<PrintDataDeliveryProps> = (data) => <PrintDataDelivery {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'PRINT_DATA_DELIVERY')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 20,
    props: { ...data }
  }
}

export default PrintDataDeliveryPage
